import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { VaIconModule, VaImageGalleryComponent, VaSafeHtmlModule } from '@vendasta/uikit';
import { VaAddonListModule } from '../addon-list/addon-list.module';
import { VaFaqsModule } from '../faqs/faqs.module';
import { VaFilesModule } from '../files/files.module';
import { VaHeaderContainerModule } from '../header-container/header-container.module';
import { VaPricingModule } from '../pricing/pricing.module';
import { RestrictionsModule } from '../restrictions/restrictions.module';
import { VaSellingInfoModule } from '../selling-info/selling-info.module';
import { VaProductDetailsComponent } from './product-details.component';

@NgModule({
  imports: [
    VaImageGalleryComponent,
    CommonModule,
    VaIconModule,
    VaPricingModule,
    VaFilesModule,
    VaFaqsModule,
    VaSellingInfoModule,
    VaHeaderContainerModule,
    VaSafeHtmlModule,
    VaAddonListModule,
    RestrictionsModule,
    MatCardModule,
  ],
  declarations: [VaProductDetailsComponent],
  exports: [VaProductDetailsComponent],
})
export class VaProductDetailsModule {}
